import { AVATAR_URL } from "./api-url.constants";
import type { AvatarUploadResponse } from "./avatar.api.model";
import { CustomError } from "@/services/API";
import { type CustomErrorResponse, API_METHODS } from "../../shared";

export const checkAvatarExists = async (): Promise<boolean> => {
  const response = await fetch(AVATAR_URL, {
    method: API_METHODS.GET,
    credentials: "include",
  });

  // Cancel the body stream to free resources without downloading the image
  await response.body?.cancel();

  return response.ok;
};

export const uploadAvatar = async (file: File): Promise<AvatarUploadResponse> => {
  const formData = new FormData();
  formData.append("avatar", file);

  const response = await fetch(AVATAR_URL, {
    method: API_METHODS.POST,
    credentials: "include",
    body: formData,
  });

  const data = (await response.json()) as AvatarUploadResponse | CustomErrorResponse;

  if ("statusCode" in data) {
    throw new CustomError(data);
  }

  return data;
};

export const deleteAvatar = async (): Promise<void> => {
  const response = await fetch(AVATAR_URL, {
    method: API_METHODS.DELETE,
    credentials: "include",
  });

  if (!response.ok) {
    const data = (await response.json()) as CustomErrorResponse;
    throw new CustomError(data);
  }
};

export const AVATAR_IMAGE_URL = AVATAR_URL;
